import {
    TIME_REPORT_SET_SELECTED_ROW
} from './actionTypes';

export function selectedRow(row) {
    return {
        type: TIME_REPORT_SET_SELECTED_ROW,
        row
    }
};